var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var semver = require('semver');

var PragmaDirective = {
  print: function print(_ref) {
    var node = _ref.node;
    // @TODO: remove hack once solidity-parser-antlr is fixed
    var value = node.value.replace(/([<>=])/g, ' $1').replace(/< =/g, '<=').replace(/> =/g, '>=').trim();

    if (value.split(' ').length > 1) {
      value = semver.validRange(value);
    }

    return concat(['pragma ', node.name, ' ', value, ';']);
  }
};
module.exports = PragmaDirective;